import React from 'react'
import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import { Link, Redirect } from 'react-router-dom';

const ChoosePrintFormat = ({
    transIdname,
    formats,
    week, 
    basicUrl,
    closePagePath
}) => (
    <WrapperPageSimple 
        pageTitleTransId={transIdname} 
        closePagePath={closePagePath}
    >
        <div className="print-page print-format site-content">
            {formats.map(formatID => {
                const format = printConfig.formats[formatID]
                const {path, height, width, landscape} = format
                const linkPath = `${basicUrl}/${path}/${landscape}/${week}`
                const className = formatID.toLowerCase()

                if(formats.length === 1) {
                    return <Redirect key={formatID} to={linkPath}/>
                }  else {
                    return (
                        <Link key={formatID} className={"format-link-wrapper " + className} to={linkPath}>
                            <div className="format-link-content">
                                <div className="format-icon-wrapper">
                                    <div className={"icon " + className}>
                                        <p className="format-title title-large-light">{path}</p>
                                    </div>
                                </div>
                                <p className="format-dimensions text-light-uppercase">{width} x {height}</p>
                            </div>
                        </Link>
                    )
                }
            })}
        </div>
    </WrapperPageSimple>
)



export default ChoosePrintFormat